import React from 'react';
import { Link } from 'react-router-dom';
import SEOComponent from '../components/SEOComponent';

const NotFound = () => {
    
    return (
        <>
            <SEOComponent 
                title="Page Not Found - 404"
                description="The page you're looking for doesn't exist. Return to our homepage to find information about Shan De Children's Welfare Home."
                keywords="404, page not found, error"
                url="/404"
            />
            <div className="container text-center py-5">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <h1 className="display-1 fw-bold text-shande-accent">404</h1>
                        <h2 className="mb-4">Page Not Found</h2>
                        <p className="text-muted mb-4">
                            The page you're looking for doesn't exist or has been moved.
                        </p>
                        <Link 
                            to="/" 
                            className="btn btn-primary btn-lg"
                        >
                            Return to Homepage
                        </Link>
                        <div className="mt-5">
                            <h3>Quick Links</h3>
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <Link to="/aboutUs" className="btn btn-outline-primary m-1">About Us</Link>
                                    <Link to="/contactUs" className="btn btn-outline-primary m-1">Contact Us</Link>
                                </div>
                                <div className="col-md-6">
                                    <Link to="/donate" className="btn btn-outline-success m-1">Donate</Link>
                                    <Link to="/news" className="btn btn-outline-primary m-1">News</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NotFound;
